module.exports = __webpack_public_path__ + "media/our_mission/photo_5-8a5ed643.webp";